module.exports = __webpack_public_path__ + "static/media/card_reader_insert.2bfb2b7c.gif";